export default "__VITE_ASSET__rvWkJaaJ__"